import { FoodType, LogMealAbleFoodType, MealType } from "model/food/types"
import { INutrition } from "model/food/types/base.types"
import { isMyFood } from "../typeGuards/foodTypeGuards"
import { getGramFromIngredients } from "model/food/utils/getPayloads/gram"
import { isAIScanMeal, isMyMeal } from "../typeGuards/mealTypeGuards"

export const getNutritionPayload = (
  food: FoodType | LogMealAbleFoodType | MealType,
): INutrition => {
  let gram = food.gram

  if (isMyFood(food)) {
    gram = getGramFromIngredients(food.ingredients)
  }

  return {
    calorie: food.calorie,
    protein: food.protein,
    carbohydrate: food.carbohydrate,
    fat: food.fat,
    gram,
  }
}

export const getMealNutritionPayload = (meal: MealType): INutrition => {
  let gram = meal.gram

  if (isMyMeal(meal) || isAIScanMeal(meal)) {
    gram = getGramFromIngredients(meal.ingredients)
  }

  return {
    calorie: meal.calorie,
    protein: meal.protein,
    carbohydrate: meal.carbohydrate,
    fat: meal.fat,
    gram,
  }
}

export const getPortionUnitPayload = (
  food: FoodType | LogMealAbleFoodType | MealType,
) => {
  return {
    unit: food.unit,
    portion: food.portion,
  }
}

const getBaseMealPayloadFromFood = (food: LogMealAbleFoodType) => {
  const baseMealPayload = {
    foodId: food.id!,
    name: food.name,
    ...getNutritionPayload(food),
    ...getPortionUnitPayload(food),
  }

  return baseMealPayload
}

export default getBaseMealPayloadFromFood
